/**
 * Données de GridPanel
 */
export enum EnumGridPanelData {
    DataSet = 1,
    Object = 2
}